function getConsole() {
  if (typeof window !== "undefined") {
    return window.console;
  }
  return global.console;
}
const console = getConsole();

function cached(fn) {
  const cache = Object.create(null);
  return function cachedFn(str) {
    const hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
}

const regex = /-(\w)/g;
const camelize = cached(str =>
  str.replace(regex, (_, c) => (c ? c.toUpperCase() : ""))
);

function removeNode(node) {
  if (node.parentElement !== null) {
    node.parentElement.removeChild(node);
  }
}

function insertNodeAt(fatherNode, node, position) {
  const refNode =
    position === 0
      ? fatherNode.children[0]
      : fatherNode.children[position - 1].nextSibling;
  fatherNode.insertBefore(node, refNode);
}

function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        //console.log("Fallback: Copying text command was " + msg);
    } catch (err) {
        console.error("Fallback: Oops, unable to copy", err);
    }

    document.body.removeChild(textArea);
}
function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(
        function() {
            //console.log("Async: Copying to clipboard was successful!");
        },
        function(err) {
            console.error("Async: Could not copy text: ", err);
        }
    );
}
function addIds(sections) {
  let ids = []
  for (let i = 0; i < sections.length; i++) {
      ids.push(sections[i].id);
      if (sections[i].sections) {
        for (let j = 0; j < sections[i].sections.length; j++) {
          ids.push(sections[i].sections[j].id);
        }
      }
  }
  return ids;
}

function buildSectionUrl(data) {
    let url = `${process.env.VUE_APP_API_PATH}/rules/section/`;
    
    if (data.id && !data.isSub) {
        url += `${data.id}/`;
    }
    
    return url;
}

function createSectionFormData(data) {
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('topSection', data.topSection);
    formData.append('type', 'saveSection');
    if (data.force) {
      formData.append('force', data.force);
    }
    return formData;
}

function updateSectionState(context, data, id) {
    if (data.isTop) {
        context.dispatch('getTopSection');
    } else {
        context.dispatch('getSections', {id: data.activeTopSection});
        
        if (id) {
            context.commit('rules/addChildId', {pid: data.topSection, id: id}, {root: true});
        }
    }
}
function findSectionById(sections, targetId) {
  if (!Array.isArray(sections)) {
      return null;
  }
  
  for (let section of sections) {
      if (section.id == targetId) {
          return { section, parentSection: null };
      }
      
      if (Array.isArray(section.sections) && section.sections.length > 0) {
          for (let subsection of section.sections) {
              if (subsection.id == targetId) {
                  return { section: subsection, parentSection: section };
              }
          }
      }
  }
  return null;
}

export { insertNodeAt, camelize, console, removeNode, copyTextToClipboard, addIds, buildSectionUrl, createSectionFormData, updateSectionState, findSectionById };
